import {Component} from "react";
import React from "react";
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid';
import PropTypes from "prop-types";
import { media } from 'styled-bootstrap-grid';
import {connect} from "react-redux";
import Text from "../atoms/Text";



const Caption = styled.h1`
  text-transform: lowercase;
  color: ${props => props.darkText ? "#333333" : "white"};
`;


const ColLeft = styled(Col)`
  padding-right: 18px;
  padding-left: 18px;
  padding-bottom: var(--pad);
  ${media.lg`
  padding-right: calc(var(--pad, 1px) / 2) !important;
        
  `}
`;

const ColRight = styled(Col)`
  padding-right: 18px;
  padding-left: 18px;
  padding-bottom: var(--pad);
  ${media.lg`
  padding-left: calc(var(--pad, 1px) / 2) !important;
        
  `}
`;


const PaddedContainer = styled(Container)`
  
`;


class DoubleTextBlock extends Component {
    render(){

        return (
            <Container>
                <Row justifyContent={"center"}>
                    <ColLeft col={12} lg={6} noGutter>
                        {this.props.noCaptionLeft ?
                            null
                            :
                            <Caption darkText={this.props.darkText}>
                                {this.props.captionLeft}
                            </Caption>
                        }
                        <Text blockText={this.props.blockText} darkText={this.props.darkText} centeredText={this.props.centeredText}>
                            {this.props.textLeft}
                        </Text>
                    </ColLeft>

                    <ColRight col={12} lg={6} noGutter>
                        {this.props.noCaptionRight ?
                            null
                            :
                            <Caption darkText={this.props.darkText}>
                                {this.props.captionRight}
                            </Caption>
                        }
                        <Text blockText={this.props.blockText} darkText={this.props.darkText} centeredText={this.props.centeredText}>
                            {this.props.textRight}
                        </Text>
                    </ColRight>
                </Row>
            </Container>
        );
    }
}


DoubleTextBlock.propTypes = {
    captionLeft: PropTypes.object.isRequired,
    captionRight: PropTypes.object.isRequired,
    noCaptionLeft: PropTypes.bool,
    noCaptionRight: PropTypes.bool,
    textLeft: PropTypes.object.isRequired,
    textRight: PropTypes.object.isRequired,
    darkText: PropTypes.bool,
    centeredText: PropTypes.bool,
    blockText: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    device: state.device
});


export default DoubleTextBlock = connect(mapStateToProps)(DoubleTextBlock);